import { useEffect, useState } from "react";

const TICK_MS = 1700;

/** Counts up every 1.7s while `active`, restarting from zero each time it turns on. */
export function useTick(active: boolean) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!active) return;
    setTick(0);
    const interval = setInterval(() => setTick((t) => t + 1), TICK_MS);
    return () => clearInterval(interval);
  }, [active]);
  return tick;
}
